import { render, staticRenderFns } from "./ModalGestor.vue?vue&type=template&id=d2ff3b42&scoped=true"
import script from "./ModalGestor.vue?vue&type=script&lang=js"
export * from "./ModalGestor.vue?vue&type=script&lang=js"
import style0 from "./ModalGestor.vue?vue&type=style&index=0&id=d2ff3b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ff3b42",
  null
  
)

export default component.exports